import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  hasConsentPdfScalarAnswer,
  shouldShowConsentPdfNotAnswered
} from 'src/app/core/api/consent-form.util';
import {
  FormFieldConfig,
  RadioConfig,
  formTemplateGenericSort
} from './../../../form-template-model';
import { FormTemplateGeneratorService } from './../../form-template-generator.service';

@Component({
  selector: 'csi-form-template-radio-field-generator',
  templateUrl: './form-template-radio-field-generator.component.html',
  styleUrls: ['./form-template-radio-field-generator.component.css']
})
export class FormTemplateRadioFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: RadioConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() formTemplateGroupFormGroup: FormGroup;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() isConsentForm: boolean = false;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  /** Consent PDF: show when optional question was left blank. */
  public showNotAnswered = false;

  sortValues = formTemplateGenericSort;
  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    this.showNotAnswered = shouldShowConsentPdfNotAnswered(
      this.isConsentForm,
      this.formatForPDF,
      hasConsentPdfScalarAnswer(this.control && this.control.value)
    );
  }
}
